import { IS_LOADING, IS_SAVING } from '../constants.js'
import { REDUCER_NAME, SELL_INQUIRY_FORM_DATA, SELL_INQUIRY_FORM_FILE_DATA } from './constants.js'

export const state = {
	[REDUCER_NAME]: {
		[IS_LOADING]: false,
		[IS_SAVING]: false,
		[SELL_INQUIRY_FORM_DATA]: null,
		[SELL_INQUIRY_FORM_FILE_DATA]: null
	}
}
